export const CalendarArrowIcon = () => (
	<svg
		width='12'
		height='12'
		viewBox='0 0 12 12'
		fill='none'
		xmlns='http://www.w3.org/2000/svg'
	>
		<path
			d='M6.83979 9.03555C6.83979 8.94055 6.87479 8.84555 6.94979 8.77055L9.71979 6.00055L6.94979 3.23055C6.80479 3.08555 6.80479 2.84555 6.94979 2.70055C7.09479 2.55555 7.33479 2.55555 7.47979 2.70055L10.5148 5.73555C10.6598 5.88055 10.6598 6.12055 10.5148 6.26555L7.47979 9.30055C7.33479 9.44555 7.09479 9.44555 6.94979 9.30055C6.87479 9.23055 6.83979 9.13055 6.83979 9.03555Z'
			fill='#566F83'
		/>
		<path
			d='M1.37504 6C1.37504 5.795 1.54504 5.625 1.75004 5.625L10.165 5.625C10.37 5.625 10.54 5.795 10.54 6C10.54 6.205 10.37 6.375 10.165 6.375L1.75004 6.375C1.54504 6.375 1.37504 6.205 1.37504 6Z'
			fill='#566F83'
		/>
	</svg>
);
